import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import clsx from "clsx";

const ImageCaption = ({ data }) => {
	const { content, image, alternate } = data;
	return (
		<div>
			<Image className={clsx(alternate ? "md:float-right md:ml-5" : "md:float-left md:mr-5",
				"w-full md:w-[20%]"
			)} image={image} to={image?.url} />
			<div className="pt-6 text-justify"><RichText value={content} /></div>
		</div>

	);
};

export default ImageCaption;